import { ComponentType } from 'react'
import { EphemeralChatSurface } from '../../core/types/chat.types'

// Registry maps surface kind to the React component that renders it.
// Components receive `surface` as a prop and call `onSubmit` when done.
export type EphemeralSurfaceProps = {
  surface: EphemeralChatSurface
  onSubmit: (surface: EphemeralChatSurface) => void
  onAttachFiles: (files: FileList | File[]) => void
}

// Forward-declared; populated lazily to avoid circular deps.
// Phase 4 will register AnalyzeUploadSurface here.
const ephemeralSurfaceRegistry: Partial<
  Record<EphemeralChatSurface['kind'], ComponentType<EphemeralSurfaceProps>>
> = {}

export function registerEphemeralSurface(
  kind: EphemeralChatSurface['kind'],
  component: ComponentType<EphemeralSurfaceProps>,
): void {
  ephemeralSurfaceRegistry[kind] = component
}

export function resolveEphemeralSurface(
  kind: EphemeralChatSurface['kind'],
): ComponentType<EphemeralSurfaceProps> | null {
  return ephemeralSurfaceRegistry[kind] ?? null
}
